<template>
  <div class="between m-t-60">
    <!-- <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_1"> -->
    <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_4">
      <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          基本信息
        </tx-bg>
      </tx-bg>

      <div class="column px-40 pt-16" v-if="tree_num1">
        <t-row
          title="神通点"
          valueClass="roleinfo-attr-value row-value-bg"
          :value="phantom['new_shentong_total'] || 0"
          class="m-tb-4"
        />

        <!-- TODOD -->
        <t-row
          title="已加点"
          valueClass="roleinfo-attr-value row-value-bg"
          :value="phantom['new_shentong_total'] - phantom['new_shentong']"
          class="m-tb-4"
        />
      </div>

      <template v-if="tree_num2">
        <div class="middle m-t-16">
          <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
            召唤
          </tx-bg>
        </div>
        <div class="column px-40">
          <t-row
            title="神通点"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom['new_summon_total'] || 0"
            class="m-tb-4"
          />

          <!-- TODOD -->
          <t-row
            title="已加点"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom['new_summon_total'] - phantom['new_summon']"
            class="m-tb-4"
          />
        </div>
      </template>
    </tx-bg>

    <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_4">
      <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          神通树
        </tx-bg>
      </tx-bg>

      <div class="px-40 pt-16" v-if="tree_num1">
        <div class="middle">
          <div class="sts-bg">
            <template v-for="(v, k) in tree_desc(tree_num1)">
            <commonItem
              class="sts-item"
              :style="coordinate(v['coordinate'])"
              
              v-if="v['icon']"
              :key="k"
              :content="v['content']"
              :score="tree_level(tree_num1)[k] || 0"
              :src="yhz_img2(v['icon'], 2)"
            />
            </template>
          </div>
        </div>

      </div>
    </tx-bg>

    <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_4">
      <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3">
        <!-- <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          召唤树
        </tx-bg> -->
      </tx-bg>

      <!-- <template v-if="tree_num2">
        <div class="px-40 pt-16">
          <div>
            <div class="yhzBgpostion">
              <img :src="bg_num(phantom['bg_num'])" />
            </div>
            <ul class="yhz_skpostion">
              <li
                :style="coordinate(v['coordinate'])"
                v-for="(v, k) in tree_desc(tree_num2)"
                :key="k"
              >
                <commonItem
                  :content="v['content']"
                  :score="tree_level(tree_num2)[k] || 0"
                  :src="yhz_img2(v['icon'], 2)"
                />
              </li>
            </ul>
          </div>
        </div>
      </template> -->
    </tx-bg>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';

const { yhz_img2, bg_num } = inject('filters');

const props = defineProps({
  phantom: {
    type: Object,
    default: () => ({}),
  },
});

const coordinate = (value) => {
  // let zoom = 0.66;
  let zoom = 1;
  let result = {};
  if (value) {
    result = {
      // left: `${(value[0]) * zoom}px`,
      left: `${(value[0] + 6) * zoom}px`,
      top: `${(value[1] + 4.8) * zoom}px`,
    };
  }
  return result;
};

const tree_num1 = computed(() => {
  if (!props.phantom.new_tree_num) return false;
  return props.phantom.new_tree_num[0];
});

const tree_num2 = computed(() => {
  if (!props.phantom.new_tree_num) return false;
  return props.phantom.new_tree_num[1];
});

const tree_desc = computed(() => {
  return (tree_num) => props.phantom?.new_tree_desc[tree_num] || {};
});

const tree_level = computed(() => {
  return (tree_num) => props.phantom?.new_tree[tree_num] || {};
});
</script>

<style scoped lang="scss" postcss="false">
.sts-bg {
  // width: 146px;
  // height: 528px; //  800 * 0.66 = 528
  
  width: 221px;
  height: 800px; 
  background: url('https://tx3.res.netease.com/qt/10/0427_yxb/images/yuanhun/st_tree_flower.png');
  background-repeat: round;
  position: relative;;
  zoom: 0.9;
}

.yhz_skpostion li img {
  width: 24px !important;
  height: 24px !important;
}

.sts-item{
  position: absolute;
}
</style>